module.exports = __webpack_public_path__ + "static/img/icon5.2ee1919.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/all/icon5.png
// module id = WvJm
// module chunks = 0